<template>
  <div class="rd-screen">
    <report-tools :copy="groups.length > 0" @copy="copyOrders"></report-tools>

    <report-state v-if="isRange" icon="mdi-calendar-today" :title="$t('daily_report')"></report-state>
    <report-state
      v-else-if="!selectedCompany"
      icon="mdi-domain"
      :title="$t('report_mobile.employees_pick_company')"
    ></report-state>
    <report-state v-else-if="loading" kind="loading"></report-state>
    <report-state
      v-else-if="!groups.length"
      icon="mdi-table"
      :title="emptyTitle"
      :text="emptyText"
    ></report-state>

    <template v-else>
      <section v-for="group in groups" :key="group.id" class="rd-slips">
        <div class="rd-slips__head">
          <report-shift-tag :shift="group.id" long></report-shift-tag>
          <i class="rd-order-card__rule"></i>
          <span class="rd-num">{{ groupSummary(group) }}</span>
        </div>

        <div class="rd-slips__grid">
          <article v-for="slip in group.slips" :key="slip.key" class="rd-slip" :data-shift="group.id">
            <header class="rd-slip__head">
              <span class="ui-avatar ui-avatar--neutral ui-avatar--sm">{{ slip.initials }}</span>
              <b class="rd-slip__name" :title="`ID ${slip.id}`">{{ slip.name }}</b>
              <span v-if="slip.orderId" class="rd-slip__no rd-num">#{{ slip.orderId }}</span>
            </header>
            <ul>
              <li v-for="(meal, index) in slip.meals" :key="index">
                <b class="rd-num">{{ meal.total }}× </b>
                <span>{{ meal.name }}</span>
              </li>
            </ul>
          </article>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import ReportMealsTabOrders from "@/components/report/meals/tabs/ReportMealsTabOrders.vue";
import hasOrderSlips from "../../shared/hasOrderSlips";
import hasShiftSubtitle from "../../shared/hasShiftSubtitle";
import ReportShiftTag from "../../shared/ReportShiftTag.vue";
import { copyText, rowsToTsv } from "../copyTable";
import ReportState from "../ReportState.vue";
import ReportTools from "../ReportTools.vue";

const SHIFT_NAMES = { 1: "one", 2: "two", 3: "three", 4: "four" };

/**
 * Naručeno na računaru: jedna firma, po smenama kartice radnika sa njihovim obrocima (kao porudžbenica).
 * Firmu, smene, period i pretragu čita iz zajedničke trake. Nasleđuje učitavanje, pretragu, štampu i Excel
 * iz ReportMealsTabOrders (štampa i Excel prate izabrane smene i pretragu); podela po smenama je u hasOrderSlips.
 */
export default {
  name: "ReportDesktopOrdered",
  extends: ReportMealsTabOrders,
  mixins: [hasOrderSlips, hasShiftSubtitle],
  components: { ReportShiftTag, ReportState, ReportTools },
  computed: {
    kpis() {
      return [
        { key: "workers", label: this.$t("report_desktop.workers"), value: this.workerTotal, tone: "inverse" },
        { key: "meals", label: this.$t("report_desktop.total_meals"), value: this.mealTotal },
      ];
    },
  },
  watch: {
    kpis: {
      handler(kpis) {
        this.$emit("kpis", this.groups.length ? kpis : []);
      },
      immediate: true,
    },
    loading(loading) {
      this.$emit("loading", loading);
    },
  },
  methods: {
    async copyOrders() {
      const headers = [this.$t("shifts"), this.$t("worker"), "#", this.$t("meals")];
      const rows = this.groups.flatMap((group) =>
        group.slips.map((slip) => [
          this.$t(`shift.${SHIFT_NAMES[group.id]}`),
          slip.name,
          slip.orderId,
          slip.meals.map((meal) => `${meal.total}× ${meal.name}`).join("; "),
        ])
      );
      const copied = await copyText(rowsToTsv(headers, rows));
      this.$emit("toast", this.$t(copied ? "report_desktop.copied" : "report_desktop.copy_failed"));
    },
  },
};
</script>
